import React, { useState } from 'react'
import { Wrapper } from './styles'
import { logout, useMe } from '../../../zustand/store'
import { Button, Typography } from 'antd';
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input';
import { Modal } from 'antd-mobile';

const LogOutSection = () => {
    const [visible, setVisible] = useState(false)
    return <>
        <Button danger onClick={() => setVisible(true)}>LogOut</Button>

        <Modal
            visible={visible}
            content='Do you really want to logout'
            closeOnAction
            onClose={() => setVisible(false)}
            closeOnMaskClick
            actions={[
                {
                    key: 'confirm',
                    text: 'Confirm',
                    onClick: () => {
                        logout();
                        console.log("Confirmed")
                    }
                },
            ]}
        />
    </>
}

function AccountPage() {
    const me = useMe();

    return (
        <Wrapper>
            <div>
                <Typography.Text>Name: </Typography.Text><Typography.Text strong>{me.data?.name}</Typography.Text>
            </div>
            <div>
                <Typography.Text>Phone: </Typography.Text><Typography.Text strong>{formatPhoneNumber(me.data?.phone_number)}</Typography.Text>
            </div>
            <div style={{ margin: "auto auto 0" }}>
                <LogOutSection />
            </div>
        </Wrapper>
    )
}

export default AccountPage